import { render, staticRenderFns } from "./EmployeeBalanceView.vue?vue&type=template&id=8ceb6cc2&"
import script from "./EmployeeBalanceView.vue?vue&type=script&lang=js&"
export * from "./EmployeeBalanceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports